module.exports = __webpack_public_path__ + "img/stop.9aede8aa.svg";